import { render, staticRenderFns } from "./DrawCateEdit.vue?vue&type=template&id=0bbc826f&scoped=true"
import script from "./DrawCateEdit.vue?vue&type=script&lang=js"
export * from "./DrawCateEdit.vue?vue&type=script&lang=js"
import style0 from "./DrawCateEdit.vue?vue&type=style&index=0&id=0bbc826f&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbc826f",
  null
  
)

export default component.exports